import { nonEmptyStringValidator } from '@vista/omnichannel-components-domain';
import { Validator } from '@vista-digital/validator';
export const defaultItemModalAssets = {
    addItemButtonIconName: 'shopping-cart',
    closeModalButtonIconName: 'cross'
};
export const itemModalAssetsValidatorSchema = {
    addItemButtonIconName: Validator.optional(nonEmptyStringValidator),
    closeModalButtonIconName: nonEmptyStringValidator
};
